import ResumeBanner from './ResumeBanner'
export default ResumeBanner
